'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _container = require('@hixme-ui/container');

var _container2 = _interopRequireDefault(_container);

var _StyledSidebarContainer = require('./StyledSidebarContainer');

var _StyledSidebarContainer2 = _interopRequireDefault(_StyledSidebarContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppSidebar = function AppSidebar(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    _StyledSidebarContainer2.default,
    null,
    _react2.default.createElement(
      _container2.default,
      { role: 'navigation' },
      children
    )
  );
};

AppSidebar.propTypes = {
  children: _propTypes2.default.node
};

AppSidebar.defaultProps = {
  children: null
};

exports.default = AppSidebar;
//# sourceMappingURL=AppSidebar.js.map


//////////////////
// WEBPACK FOOTER
// ../app-layout/lib/components/AppSidebar/AppSidebar.js
// module id = 258
// module chunks = 0